// Handles toggling the accordions open/close state

function toggleAccordion() {
    // Get all accordion elements
    const accordions = document.querySelectorAll('.user_mode .pageEl.accordion');
    
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        accordion.addEventListener('click', function(e) {
            // Prevent click from bubbling up
            e.stopPropagation();
            
            // Toggle the ac-open class
            this.classList.toggle('ac-open');
            
            // Optional: Close other open accordions
            // accordions.forEach(item => {
            //     if (item !== this && item.classList.contains('ac-open')) {
            //         item.classList.remove('ac-open');
            //     }
            // });
        });
    });
}